export type LabelInventoryDateRow = {
  createdAt?: unknown;
  expiresAt?: unknown;
  pdfExpirySource?: unknown;
  sourceCreatedAt?: unknown;
  status?: unknown;
};

export type LabelInventoryExpiryUrgency = "expired" | "known" | "unknown" | "warning";

function clean(value: unknown) {
  return String(value || "").trim();
}

function timestamp(value: unknown) {
  const parsed = Date.parse(clean(value));
  return Number.isFinite(parsed) ? parsed : null;
}

export function labelInventoryPdfCreatedAt(row: LabelInventoryDateRow) {
  return timestamp(row.sourceCreatedAt) === null ? null : clean(row.sourceCreatedAt);
}

export function labelInventoryExpiryMeta(
  row: LabelInventoryDateRow,
  nowMs = Date.now()
): { detail: string; expiresAt: string | null; known: boolean; urgency: LabelInventoryExpiryUrgency } {
  const expiresAt = clean(row.expiresAt);
  const expiresAtMs = timestamp(expiresAt);
  const verified = clean(row.pdfExpirySource).toLowerCase() === "embedded_javascript";
  if (!verified || expiresAtMs === null) {
    return {
      detail: "PDF içinde doğrulanmış bitiş tarihi yok",
      expiresAt: null,
      known: false,
      urgency: "unknown",
    };
  }

  const differenceMs = expiresAtMs - nowMs;
  const absoluteDays = Math.ceil(Math.abs(differenceMs) / 86_400_000);
  if (differenceMs < 0 || clean(row.status).toLowerCase() === "expired") {
    return {
      detail: `${Math.max(1, absoluteDays)} gün önce doldu`,
      expiresAt,
      known: true,
      urgency: "expired",
    };
  }
  if (differenceMs <= 86_400_000) {
    return { detail: "Bugün sona eriyor", expiresAt, known: true, urgency: "warning" };
  }
  return {
    detail: `${absoluteDays} gün kaldı`,
    expiresAt,
    known: true,
    urgency: absoluteDays <= 30 ? "warning" : "known",
  };
}
